import { Flight } from '@ibe/models';

export class AncillaryListItem {
	name: string;
	icon: string;
	destination: string;
	quantity: number;
	cost: any;
	flight: Flight;
	link: string;
	id?: string;

	constructor(name: string, icon: string, destination: Flight, quantity: number, cost: number, link: string, id?: string) {
		this.name = name;
		this.icon = icon;
		if (destination) {
			this.flight = destination;
			this.destination = `${destination.departure.airport.location.city} — ${destination.arrival.airport.location.city}`;
		}
		this.quantity = quantity;
		this.cost = cost;
		this.link = link;
		this.id = id;
	}
}
